export default {
    control: {
        backgroundColor: '#fff',
        fontSize: 14,
        fontWeight: 'normal',
    },

    '&multiLine': {
        control: {
            fontFamily: 'monospace',
            minHeight: 63,
        },
        highlighter: {
            padding: '11px 14px',
            border: '1px solid transparent',
            lineHeight: 1.2857
        },
        input: {
            // padding: 9,
            // border: '1px solid silver',
            height: 'auto',
            minHeight: '100%',
            maxHeight: '100%',
        },
    },

    '&singleLine': {
        display: 'inline-block',
        width: '100%',

        highlighter: {
            padding: '8px 14px',
            border: '2px inset transparent',
        },
        input: {
        },
    },

    suggestions: {
        list: {
            backgroundColor: 'white',
            border: '1px solid rgba(0,0,0,0.15)',
            fontSize: 14,
        },
        item: {
            padding: '5px 15px',
            borderBottom: '1px solid rgba(0,0,0,0.15)',
            '&focused': {
                backgroundColor: '#cee4e5',
            },
        },
    },
}